module.exports = __webpack_public_path__ + "img/w3_circle_close_black.9c6a4972.png";